export const DistributionStatus = {
  Empty: 'EMPTY',
  Ready: 'READY',
  Distributed: 'DISTRIBUTED',
  Complete: 'COMPLETE',
} as const;

export type DistributionStatusType =
  (typeof DistributionStatus)[keyof typeof DistributionStatus];
